export default "__VITE_ASSET__Dbh0O6Oi__"